import type { useInstallApp } from '@/hooks/useInstallApp';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function InstallApp({ state }: { state: ReturnType<typeof useInstallApp> }) {
  const { t } = useTranslation();
  const ios =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return (
    <section
      aria-labelledby="install-title"
      className="flex flex-col gap-3 rounded-card border border-line bg-surface p-5"
    >
      <h2 id="install-title" className="font-medium">
        {t('install.title')}
      </h2>
      <p className="text-sm text-ink-2">
        {t(state.installed ? 'install.installed' : ios ? 'install.ios' : 'install.browser')}
      </p>
      {!state.installed && state.canPrompt && (
        <Button onClick={() => void state.install()} disabled={state.busy}>
          {t('install.action')}
        </Button>
      )}
      {state.failed && (
        <p role="alert" className="text-sm text-ink-2">
          {t('install.failed')}
        </p>
      )}
    </section>
  );
}
